import type { RegistrationData, RegistrationErrors } from '@/types'

export const validateEmail = (email: string): string | null => {
  if (!email) return 'Email is required'
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email) ? null : 'Invalid email format'
}

export const validatePassword = (password: string): string | null => {
  if (!password) return 'Password is required'
  if (password.length < 8) return 'Password must be at least 8 characters'

  const hasUpperCase = /[A-Z]/.test(password)
  const hasLowerCase = /[a-z]/.test(password)
  const hasNumbers = /[0-9]/.test(password)
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)

  if (!(hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar)) {
    return 'Password must include uppercase, lowercase, numbers, and special characters'
  }

  return null
}

// export const validateName = (name: string, field = 'Name'): string | null => {
//   if (!name || name.trim() === '') return `${field} is required`
//   if (name.length < 2) return `${field} must be at least 2 characters`
//
//   const englishLettersOnly = /^[A-Za-z]+$/
//   if (!englishLettersOnly.test(name)) {
//     return `${field} must contain only English letters`
//   }
//
//   return null
// }

// export const validatePhone = (phone: string): string | null => {
//   if (!phone) return 'Phone number is required'
//   const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/
//   return phoneRegex.test(phone) ? null : 'Invalid phone number format'
// }

// export const validateCompanyInfo = (field: string, value: string | string[]): string | null => {
//   switch (field) {
//     case 'companyName':
//       return !value ? 'Company name is required' : null
//     case 'region':
//       return !value ? 'Please select a region' : null
//     case 'industry':
//       return !value ? 'Please select an industry' : null
//     case 'industries':
//       return !value || (Array.isArray(value) && value.length === 0) ? 'Please select at least one industry' : null
//     case 'companySize':
//       return !value ? 'Please select company size' : null
//     case 'annualBudget':
//       return value === '' ? 'Please select annual budget' : null
//     default:
//       return null
//   }
// }

export const sanitizeEmail = (email: string): string => {
  return (email || '').replace(/[^A-Za-zăĂâÂîÎțȚșȘ0-9@._%+-]/g, '')
}

export const sanitizePassword = (password: string): string => {
  return (password || '').replace(/[А-Яа-яЁё]/g, '')
}

export const validateRegistration = (values: Partial<RegistrationData>): RegistrationErrors => {
  const errors: RegistrationErrors = {}

  const emailError = values.email ? validateEmail(values.email) : 'Email is required'
  if (emailError) errors.email = emailError

  const passwordError = values.password ? validatePassword(values.password) : 'Password is required'
  if (passwordError) errors.password = passwordError

  if (!values.confirmPassword) {
    errors.confirmPassword = 'Confirm Password is required'
  } else if (values.password !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords must match'
  }

  return errors
}

// export const validateRegistration = (
//   values: Partial<RegistrationStepTwoData>,
// ): RegistrationErrors => {
//   const errors: RegistrationErrors = {}
//
//   const jobPositionError = values.jobPosition
//     ? validateName(values.jobPosition, 'Job Position')
//     : 'Job Position is required'
//   if (jobPositionError) errors.jobPosition = jobPositionError
//
//   if (values.phoneNumber) {
//     const phoneError = validatePhone(values.phoneNumber)
//     if (phoneError) errors.phoneNumber = phoneError
//   } else {
//     errors.phoneNumber = 'Phone number is required'
//   }
//
//   const companyNameError = validateCompanyInfo('companyName', values.companyName || '')
//   if (companyNameError) errors.companyName = companyNameError
//
//   const regionError = validateCompanyInfo('region', values.region || '')
//   if (regionError) errors.region = regionError
//
//   const industryError = validateCompanyInfo('industries', values.industries || [])
//   if (industryError) errors.industry = industryError
//
//   const companySizeError = validateCompanyInfo('companySize', values.companySize || '')
//   if (companySizeError) errors.companySize = companySizeError
//
//   const annualBudgetError = validateCompanyInfo('annualBudget', values.annualBudget || '')
//   if (annualBudgetError) errors.annualBudget = annualBudgetError
//
//   return errors
// }
